import { useGetCultureIndexPhenologicalStagesQuery } from 'services/api/Meteorology/Agro/CultureIndex';
import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';

export default function usePhenologicalStage(cultura?: string) {
  const { data, error } = useGetCultureIndexPhenologicalStagesQuery(
    cultura || '',
    { skip: !cultura },
  );

  useHandleRequestErrors(error as ResponseError);

  return {
    stages: data || [],
  };
}
